<template>
  <el-aside class="left" width="400px">
    <scenes></scenes>
    <actions></actions>
  </el-aside>
</template>

<script>
import Scenes from './LeftSidebar/Scenes.vue';
import Actions from './LeftSidebar/Actions.vue';

export default {
  components: {
    Scenes,
    Actions,
  },
};
</script>

<style lang="less" scoped>
.left {
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    max-height: 100vh;
    position: relative;
    background: #fff;
    position: relative;
  }

  .box-card + .box-card {
    margin-top: 10px;
  }
}
.box-card {
  font-size: 14px;
  span {
    display: block;
  }
  .el-input-number {
    margin-left: 10px;
    width: 100px;
  }
  .el-card__body {
    .item + .item {
      margin-top: 5px;
    }
  }
  &.text {
    font-size: 12px;
    + .text {
      margin-top: 15px;
    }
  }
}
</style>
